import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import useBrand from 'hooks/useBrand';

const Wrapper = styled('img', {
  shouldForwardProp: prop => !['maxHeight', 'brandHeight'].includes(prop),
})`
  max-width: ${({ maxHeight }) => `min(${maxHeight * 7.5}px, 100%)`};
  max-height: ${({ maxHeight }) => maxHeight}px;
  width: auto;
  height: ${({ brandHeight }) => brandHeight ? `${brandHeight}px` : 'auto'};
  object-fit: contain;
  object-position: left center;
  display: block;
`;

const Logo = ({ src, maxHeight = 36, ...rest }) => {

  const brand = useBrand();

  const brandHeight = src ? undefined : brand.preferredLogoHeight ?? maxHeight;

  return (
    <Wrapper
      maxHeight={maxHeight}
      brandHeight={brandHeight}
      src={src || brand.logo}
      alt={src ? undefined : brand.name}
      {...rest}
    />
  );
};

Logo.propTypes = {
  src: PropTypes.string,
  maxHeight: PropTypes.number,
};

export default Logo;
